import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { QuoteSteps } from './models/quote-steps';
import { EvcQuoteComponent } from './pages/evc-quote/evc-quote.component';

const routes: Routes = [];

Object.keys(QuoteSteps).forEach((value: string, index) => {
  // We redirect the base path to the first step
  if (index === 0) {
    routes.push({
      path: '',
      redirectTo: QuoteSteps[value],
      pathMatch: 'full',
    });
  }

  // We add a path for each step.
  routes.push({
    path: QuoteSteps[value],
    component: EvcQuoteComponent,
  });
});

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EvcQuoteRoutingModule {}
